import { useLazyQuery } from '@apollo/client';

import BookingSetting, { BookingSettingByBookingQueryInput } from '../models/BookingSetting';
import { GET_BOOKING_SETTINGS_BY_BOOKING } from './query';

interface QueryData {
  bookingSetting: BookingSetting;
}

interface QueryVars extends BookingSettingByBookingQueryInput {}

/**
 * Fetch all settings of the given booking
 */
function useFetchBookingSettings() {
  const [execute, { loading, error, data, refetch, called }] = useLazyQuery<QueryData, QueryVars>(
    GET_BOOKING_SETTINGS_BY_BOOKING,
    {
      notifyOnNetworkStatusChange: true,
    },
  );

  const fetchBookingSettings = async (bookingId: string) => {
    const variables: QueryVars = {
      bookingId,
    };

    const response = called
      ? await refetch(variables)
      : await execute({
          variables,
        });

    return response.data?.bookingSetting;
  };

  return { fetchBookingSettings, loading, error, settings: data?.bookingSetting };
}

export default useFetchBookingSettings;
